import AppBar from "@material-ui/core/AppBar";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CircularProgress from "@material-ui/core/CircularProgress";
import Collapse from "@material-ui/core/Collapse";
import { green, red } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import Divider from "@material-ui/core/Divider";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import {
	default as ArrowDown,
	default as ArrowDownwardIcon
} from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SaveIcon from "@material-ui/icons/Save";
import ShareIcon from "@material-ui/icons/Share";
import ThumbDownAltIcon from "@material-ui/icons/ThumbDownAlt";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import axios from "axios";
import clsx from "clsx";
import saveAs from "file-saver";
import HtmlDocx from "html-docx-js/dist/html-docx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import mammoth from "mammoth";
import React, { useState } from "react";
import { store as storeNotification } from "react-notifications-component";
import { QRCode } from "react-qrcode-logo";
import { useDispatch, useSelector } from "react-redux";
import { docSign } from "../actions/docSign";
import { docApprove, docComment, docSubmit, DocSubmitApproveCommentInitial } from "../actions/docSubmit";
import { useFetch } from "../actions/fetchData";
import { getDocs } from "../actions/getDocs";
import { saveDocBody } from "../actions/saveDocBody";
import socket from "../actions/socketIO";
import { IP } from "../config/IP";
import store from "../store/createStore";
import FullScreenDialog from "./containers/FullScreenDialog";
import InteractiveList from "./containers/List";
import Steplist from "./containers/stepslist";
import Table from "./containers/Table";
import TextEditor from "./containers/TextEditors";
import Signatures from "./Signatures";
const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightRegular,
	},
	button: {
		margin: theme.spacing(1),
	},
	small: {
		width: theme.spacing(3),
		height: theme.spacing(3),
	},
	large: {
		width: theme.spacing(7),
		height: theme.spacing(7),
	},
	media: {
		height: 0,
		paddingTop: "56.25%", // 16:9
	},
	expand: {
		transform: "rotate(0deg)",
		marginLeft: "auto",
		transition: theme.transitions.create("transform", {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expandOpen: {
		transform: "rotate(180deg)",
	},
	avatar: {
		backgroundColor: red[500],
	},
	buttonRoot: {
		display: "flex",
		alignItems: "center",
	},

	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},
	buttonSuccess: {
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[700],
		},
	},
	fabProgress: {
		color: green[500],
		position: "absolute",
		top: -6,
		left: -6,
		zIndex: 1,
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary,
	},
	appBar: {
		position: "relative",
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
}));

const DocDetails = (DocId) => {
	const state = useSelector((state) => state);
	const [FullScreenDialogInfo, setFullScreenDialogInfo] = useState();
	const [docBody, setDocBody] = useState();
	const [commentBody, setCommentBody] = useState();
	const [status, setStatus] = useState();
	let actingOfficesv = [];
	let assistant_officesv=[]
	try {
		actingOfficesv = state.userStatus.actingOfficeHierarchy[0].map(
			(y) => y.office_id
		);
	} catch (e) 
	{}

	try{
	assistant_officesv=state.officeData.allOffice.filter
	(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id)).map(y=>({office_id:y.office_id}))
		}
			catch(e)
			{}
	const [actingOffices, setActingOffices] = useState(actingOfficesv);
	const [assistant_offices,setAssistant_offices]=useState(assistant_officesv);
	const [openSavePDFFile, setOpensavePDFFile] = useState();

	const [pdfHTML, setPdfHTML] = useState();
	const [pdfName, setPdfName] = useState();

	const dispatch = useDispatch();
	const classes = useStyles();
	//setState(useFetch(DocId.DocId));
	const [firstLoad, setFirstLoad] = React.useState(true);
	const [pageNumber, setPageNumber] = React.useState(1);
	const [numberRowPerPage, setNumberRowPerPage] = React.useState(5);
	const [totalRow, setTotalRow] = React.useState(20);
	let docSignature;
	const [expanded, setExpanded] = React.useState(false);
	const token = localStorage.getItem("token");

	const handleExpandClick = () => {
		setExpanded(!expanded);
	};
	const [buttonClassname, setButtonClassname] = React.useState(
		clsx({
			[classes.buttonSuccess]: commentBody && state.docComment.isCommented,
		})
	);

	let { data, files, signature, loading, fetchData } = useFetch({
		id: DocId.DocId,
		companyId: state.companyData.selectedCompanyId,
		office_id: state.auth.user.office
			? state.auth.user.office[0].office_id
			: "",
		actingOffices: actingOffices,
		assistant_offices:assistant_offices,
		page: pageNumber,
		limit: numberRowPerPage,
	});
	let docsHistoryIn = {};
	let showDelete = false;
	let ApproveStatus = 5;

	if (!loading && data) {
		try {
			console.log("reaching DocDetails data  =", data);
			console.log("reaching DocDetails file  =", files);
			console.log("reaching DocDetails signature  =", signature);
			console.log(
				"reaching DocDetails historySituation  =",
				data.data[0].historySituation
			);
			console.log("data.data[0].status", data.data[0].status);
			let datahistory = [];
			let direction = "";
			let ownerOffice = "";
			let currentOffice = "";
			let allUser = state.auth.user.allUser;
			console.log("state.auth.user.allUser=", allUser);

			let hostorylist = data.data[0].historySituation.map((x) => {
				if (x.direction == 1) {
					direction = <ArrowUpwardIcon />;
				} else if (x.direction == -1) {
					direction = <ArrowDownwardIcon />;
				} else {
					direction = "";
				}
				ownerOffice = state.auth.user.allOffices.filter(
					(y) => y.office_id == parseInt(x.responsibleUser.office_id)
				)[0];
				currentOffice = state.auth.user.allOffices.filter(
					(y) => y.office_id == parseInt(x.currentOfficeLocation)
				)[0];
				console.log("state.auth.user.allOffices", state.auth.user.allOffices);
				console.log("x.responsibleUser.office_id", x.responsibleUser.office_id);
				console.log(
					"allUser.find",
					allUser.find((y) => y._id === x.responsibleUser.usernameId)
				);

				datahistory.push({
					usernameId: allUser.find(
						(y) => y._id === x.responsibleUser.usernameId
					).username,
					office_id: ownerOffice.office_name,
					statusDate: x.statusDate,
					_id: x._id,
					currentOfficeLocation: currentOffice.office_name,
					direction: direction,
					status: x.status,
					statusDescription: x.statusDescription,
					action: x.action,
					actionDescription: x.actionDescription,
					deleteDisabled: true,
					viewDisabled: true,
				});
			});
			console.log("datahistory=", datahistory);

			docsHistoryIn = {
				title: "Documents History",
				columns: [
					{ title: "username", field: "usernameId" },
					{ title: "Office", field: "office_id" },
					{
						title: "statusDate",
						field: "statusDate",
					},
					{ title: "currentOfficeLocation", field: "currentOfficeLocation" },
					{ title: "direction", field: "direction" },
					{ title: "statusDate", field: "statusDate" },
					{ title: "action", field: "action" },
					{ title: "actionDescription", field: "actionDescription" },
				],
				data: datahistory,
			};
		} catch (e) {}
	}
	//Start editing Text controls
	const onHandleDocBodyChange = async (e) => {
		if (e.length > 0) {
			setDocBody(e);
			console.log("docBody from home=", docBody);
		}
	};
	const onHandleCommentBodyChange = async (e) => {
		if (e.length > 0) {
			setCommentBody(e);
			console.log("commentBody from home=", commentBody);
		}
	};
	const onHandleSignChange = async (data) => {
		docSignature = data;
		console.log("docSignature from home=", data);
	};
	const handleChangeTablePage = (value) => {
		setFirstLoad(false);
		console.log("handleChangeTablePage Clicked");
		setPageNumber(value);
	};
	const onChangeTableRowsPerPage = (value) => {
		console.log("onChangeTableRowsPerPage Clicked!");
	};

	const handleClose = () => {
		console.log("handleClose clicked!");

		setFullScreenDialogInfo(
			<FullScreenDialog
				openDialog={false}
				handleClose={handleClose}
				handleSaveText={handleSaveText}
				onHandleDocBodyChange={onHandleDocBodyChange}
				docBody={docBody}
				firstText="Drafting"
				secondText="Memo"
				showInputText={true}
				onHandleSignChange={(value) => onHandleSignChange(value)}
			/>
		);
		fetchData({
			id: DocId.DocId,
			companyId: state.companyData.selectedCompanyId,
			office_id: state.auth.user.office
				? state.auth.user.office[0].office_id
				: "",
			actingOffices: actingOffices,
			assistant_offices:assistant_offices,

			page: pageNumber,
			limit: numberRowPerPage,
		});
	};
	let newstate = store.getState();
	const handleSaveText = (e, param) => {
		console.log("docSignature =", docSignature);
		let elements = document.getElementsByClassName("validation");
		while (elements.length > 0) {
			elements[0].remove();
		}

		var newItem = document.createElement("DIV"); // Create a <Div> node
		newItem.setAttribute("class", "validation");
		var textnode = document.createTextNode("Element is empty"); // Create a text node

		newItem.appendChild(textnode);
		newstate = store.getState();
		if (!newstate.draftDocs.body) {
			document.getElementById("textEditorBody").after(newItem);
			document.getElementById("textEditorBody").style.borderColor = "red";
			return console.log("message#1 newstate.draftDocs.body.docBody is empty");
		}
		if (!docSignature && param !== 6) {
			storeNotification.addNotification({
				title: "Signing!",
				message: "failed Save Doc,please sign",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			document.getElementById("textEditorBody").after(newItem);
			document.getElementById("textEditorBody").style.borderColor = "red";
			return console.log("message#0 docSignatureis empty");
		}

		if (!newstate.draftDocs.body.docBody) {
			storeNotification.addNotification({
				title: "Commenting!",
				message: "failed Save Doc,please put your Comment",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			document.getElementById("textEditorBody").after(newItem);
			document.getElementById("textEditorBody").style.borderColor = "red";
			return console.log("message#2 newstate.draftDocs.body.docBody is empty");
		}
		if (newstate.draftDocs.body.docBody) {
			if (
				!newstate.draftDocs.body.docBody
					.replace(/<p>/g, "")
					.replace(/<\/p>/g, "")
					.replace(/<br>/g, "")
			) {
				storeNotification.addNotification({
					title: "Commenting!",
					message: "failed Save Do, Please put your Comment!",
					type: "danger",
					insert: "top",
					container: "top-right",
					animationIn: ["animated", "fadeIn"],
					animationOut: ["animated", "fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				document.getElementById("textEditorBody").after(newItem);
				document.getElementById("textEditorBody").style.borderColor = "red";
				return console.log(
					"message#3 newstate.draftDocs.body.docBody is empty"
				);
			}
		}
		console.log("newstate.draftDocs.body=", newstate.draftDocs.body);

		if (
			newstate.draftDocs.body.docBody.replace(/(<([^>]+)>)/gi, "").length === 0
		) {
			storeNotification.addNotification({
				title: "Commenting!",
				message: "failed Save Do, Please put your Comment!",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			document.getElementById("textEditorBody").after(newItem);
			document.getElementById("textEditorBody").style.borderColor = "red";
			return console.log("message#34newstate.draftDocs.body.docBody is empty");
		}
		console.log(
			"(Buffer.from(newstate.draftDocs.body.docBody).length / 1024 / 1024)=",
			Buffer.from(newstate.draftDocs.body.docBody).length / 1024 / 1024
		);
		if (Buffer.from(newstate.draftDocs.body.docBody).length / 1024 / 1024 > 1) {
			storeNotification.addNotification({
				title: "Comment!",
				message:
					"failed Save Comment,comment to big size! current size is " +
					Math.round(
						Buffer.from(newstate.draftDocs.body.docBody).length / 1024 / 1024
					) +
					"Mb it should be Less that Equal to 1Mb",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return;
		}

		console.log("handleSaveText with docBody=", docBody);
		console.log("handleSaveText  with DocId=", state.inputsave.id);
		console.log("handleSaveText clicked!");
		loading = true;

		var input = {
			url: IP.nodeServer + "api/docSign",
			data: [
				{
					name: "docId",
					value: DocId.DocId,
				},
				{
					name: "signature",
					value: docSignature,
				},
				{ name: "office_id", value: data.data[0].currentOfficeLocation },
			],
		};
		console.log("DocDetails docSignature=", docSignature);

		if (docSignature) dispatch(docSign(input));
		input = {
			url: IP.nodeServer + "api/commentDoc",
			data: [
				{
					name: "docId",
					value: DocId.DocId,
				},
				{
					name: "office_id",
					value: parseInt(data.data[0].currentOfficeLocation),
				},
				{ name: "comment", value: newstate.draftDocs.body.docBody },
			],
		};

		dispatch(docComment(input));
		console.log("handleDocApproval clicked");
		loading = true;
		var input = {
			url: IP.nodeServer + "api/approveDoc",
			data: [
				{
					name: "docId",
					value: DocId.DocId,
				},
				{
					name: "office_id",
					value: parseInt(data.data[0].currentOfficeLocation),
				},
				{
					name: "status",
					value: param,
				},
			],
		};
		console.log("approve with this input=", input);
		dispatch(docApprove(input));
		loading = false;

		handleClose();
	};
	//start handle click submit button
	const handleDocSubmitButton = (e) => {
		e.preventDefault();
		console.log("handleDocSubmitButton Clicked!");

		setFullScreenDialogInfo(
			<Box borderLeft={10} borderLeft={0}>
				<FullScreenDialog
					openDialog={true}
					handleClose={handleClose}
					showInputText={false}
					dontShowCommentText={true}
					docBody={docBody}
					firstText="Comment"
					secondText="Document"
					showDrawing={true}
					handleSaveText={(e) => handleDocSubmit(e)}
					onHandleSignChange={(value) => onHandleSignChange(value)}
					//docTitle={docTitle}
				/>{" "}
			</Box>
		);
	};

	// end handle click  submit button
	const handleDocShare = () => {
		console.log("handleDocShare clicked!");
		setFullScreenDialogInfo(
			<Box borderLeft={10} borderLeft={0}>
				<FullScreenDialog
					openDialog={true}
					handleClose={handleClose}
					showInputText={false}
					dontShowCommentText={true}
					showDocUserAccess={true}
					firstText="access"
					secondText="shared users"
					showDrawing={false}
					dontShowSaveButton={true}
					data={{
						...data,
						office_id: state.auth.user.office
							? state.auth.user.office[0].office_id
							: "",
					}}

					//docTitle={docTitle}
				/>{" "}
			</Box>
		);
	};
	const handleDocApproval = (e, input) => {
		e.preventDefault();
		console.log("handleDocApproval Clicked!");
		setStatus(input);

		setFullScreenDialogInfo(
			<Box borderLeft={10} borderLeft={0}>
				<FullScreenDialog
					openDialog={true}
					handleClose={handleClose}
					handleSaveText={(e) => handleSaveText(e, input)}
					onHandleDocBodyChange={onHandleDocBodyChange}
					showInputText={false}
					docBody={docBody}
					firstText="Comment"
					secondText="Document"
					showDrawing={input === 6 ? false : true}
					onHandleSignChange={(value) => onHandleSignChange(value)}
					//docTitle={docTitle}
				/>{" "}
			</Box>
		);

		if (state.auth.user.office) {
			let inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				office_id: parseInt(state.auth.user.office[0].office_id),
				companyId: state.companyData.selectedCompanyId,
			};
			console.log(inputs);
			dispatch(getDocs(inputs));
			console.log("new state=", state);
		}
	};
	const handleDocSubmit = (e) => {
		console.log("docSignature =", docSignature);
		let elements = document.getElementsByClassName("validation");
		while (elements.length > 0) {
			elements[0].remove();
		}

		var newItem = document.createElement("DIV"); // Create a <Div> node
		newItem.setAttribute("class", "validation");
		var textnode = document.createTextNode("Element is empty"); // Create a text node

		if (!docSignature) {
			storeNotification.addNotification({
				title: "Signing!",
				message: "failed Save Doc,please sign",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			document.getElementById("drawingDv").before(newItem);
			document.getElementById("drawingDv").style.borderColor = "red";
			return console.log("message#0 docSignatureis empty");
		}
		console.log("handleDocSubmit clicked");
		let office_id = data.data[0].currentOfficeLocation;
		console.log("handleDocSubmit data=", data);

		loading = true;
		var input = {
			url: IP.nodeServer + "api/docSign",
			data: [
				{
					name: "docId",
					value: DocId.DocId,
				},
				{
					name: "signature",
					value: docSignature,
				},
				{ name: "office_id", value: data.data[0].currentOfficeLocation },
			],
		};
		console.log("DocDetails docSignature=", docSignature);

		dispatch(docSign(input));
		input = {
			url: IP.nodeServer + "api/submitDoc",
			data: [
				{ name: "docId", value: DocId.DocId },
				{
					name: "office_id",
					value: parseInt(office_id),
				},
				{ name: "status", value: 4 },
			],
		};
		console.log("submit with this input=", input);
		dispatch(docSubmit(input));
		loading = false;

		if (state.auth.user.office) {
			let inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				office_id: parseInt(state.auth.user.office[0].office_id),
				companyId: state.companyData.selectedCompanyId,
			};
			console.log(inputs);
			dispatch(getDocs(inputs));
			console.log("new state=", state);
		}
		handleClose();
	};
	const saveComment = () => {
		if (!commentBody) {
			console.log("saveComment commentBody=", commentBody);
			storeNotification.addNotification({
				title: "Comment!",
				message: "failed Save Comment,message Empty",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return;
		}
		console.log(
			"commentBody.replace=",
			commentBody.replace(/<p>/g, "").replace(/<\/p>/g, "").replace(/<br>/g, "")
		);
		if (
			!commentBody
				.replace(/<p>/g, "")
				.replace(/<\/p>/g, "")
				.replace(/<br>/g, "")
		) {
			storeNotification.addNotification({
				title: "Comment!",
				message: "failed Save Comment,message Empty",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			return;
		}
		console.log(
			"Buffer.from(commentBody).length / 1024 / 1024=",
			Buffer.from(commentBody).length / 1024 / 1024
		);
		if (Buffer.from(commentBody).length / 1024 / 1024 > 2) {
			storeNotification.addNotification({
				title: "Comment!",
				message:
					"failed Save Comment,comment to big size! current size is " +
					Math.round(Buffer.from(commentBody).length / 1024 / 1024) +
					"Mb it should be Less that Equal to 2Mb",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return;
		}

		let input = {
			url: IP.nodeServer + "api/commentDoc",
			data: [
				{
					name: "docId",
					value: DocId.DocId,
				},
				{
					name: "office_id",
					value: parseInt(data.data[0].currentOfficeLocation),
				},
				{ name: "comment", value: commentBody },
			],
		};
		console.log("saveComment input=", input);

		dispatch(docComment(input));
	};
	const handleCloseSavePDFFile = () => {
		setOpensavePDFFile(false);
	};

	const handleFileClick = (value) => {
		let file = files[0].filter((x) => x._id === value)[0].file;
		console.log("handleFileClick value=", value);
		console.log(
			"handleFileClick files=",
			files[0].filter((x) => x._id === value)[0]
		);

		var buffer = Buffer.from(file.data);
		var blob = new Blob([buffer], {
			type: file.contentType,
		});
		console.log(
			"files[0].filter((x) => x._id === value)[0].file.contentType=",
			files[0].filter((x) => x._id === value)[0].file.contentType
		);
		console.log(
			"files[0].filter((x) => x._id === value)[0].fileType=",
			files[0].filter((x) => x._id === value)[0].fileType
		);
		console.log("data.data[0].status=", data.data[0].status);
		if (
			files[0].filter((x) => x._id === value)[0].fileType === 1 &&
			[
				"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
				"application/octet-stream",
			].includes(files[0].filter((x) => x._id === value)[0].file.contentType) &&
			data.data[0].status > 3
		) {
			console.log(
				"file.name.replace(/.docs/, )+pdf",
				file.name.replace(/.docs/, "") + ".pdf"
			);
			mammoth
				.convertToHtml({ arrayBuffer: buffer })
				.then(function (resultObject) {
					//result1.innerHTML = resultObject.value;
					console.log(
						"convertToHtml resultObject.messages=",
						resultObject.messages
					);
					let htmlDoc = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>${file.name}</title>
</head>
<body>${resultObject.value} </body>
</html>`;

					if (!resultObject.value) {
						htmlDoc = htmlDoc = `<!DOCTYPE html>
<html lang="en">

  ${
		buffer
			.toString()
			.split(/<html>/)[1]
			.split(/<\/html>/)[0]
	} 
</html>`;
					}
					let signatureContent = signature[0].signature[0].data;
					let signatureName = state.auth.user.allUser.find(
						(y) => y._id === signature[0].signature[0].usernameId
					).name;
					let signatureDate = signature[0].signature[0].createdate;

					console.log("signatureContent=", signatureContent);
					var docx = HtmlDocx.asBlob(
						htmlDoc.replace(
							/<\/body>/,
							`<p><img src="${signatureContent}" width="100" heigth="50"><br/> By ${signatureName} <br/>on ${signatureDate}</p></body>`
						)
					);
					let inputHTML = htmlDoc.replace(
						/<\/body>/,
						`<p><img src="${signatureContent}" width="100" heigth="50"><br/> By ${signatureName} <br/>on ${signatureDate}</p></body>`
					);
					setPdfName(file.name);
					setPdfHTML(inputHTML);

					setOpensavePDFFile(true);
					console.log("inputHTML=", inputHTML);
					//saveAs(docx, file.name);
				});
			return;
		}

		saveAs(blob, file.name);
	};

	try {
		if (data) {
			console.log("data.data[0].StepProgress=", data.data[0].StepProgress);
			console.log("data=", data);
			if (data.data[0].status === 1) showDelete = true;
			showDelete = false;
			const steps = data.data[0].StepProgress.map((d) => d.step);

			console.log("steps=", steps);
			console.log("Math.max(...steps)=", Math.max(...steps));

			if (data.data[0].StepProgress) {
				ApproveStatus = 5;
				console.log(
					"data.data[0].StepProgress=",
					data.data[0].StepProgress.find(
						(max) => max.step === Math.max(...steps)
					)
				);
				if (
					data.data[0].StepProgress.find(
						(max) => max.step === Math.max(...steps)
					).id === data.data[0].currentOfficeLocation
				) {
					ApproveStatus = 9;
				} else {
					ApproveStatus = 5;
				}
			}
		}
	} catch (e) {
		console.error("message error=", e);
	}

	
	React.useEffect(() => {
		if (status) {
			console.log("mounting with status=", status);
		}
	}, [handleDocApproval, status, setStatus]);
	React.useEffect(() => {
		console.log("mounting  Home  with open=", FullScreenDialogInfo);
	}, [FullScreenDialogInfo, setFullScreenDialogInfo]);
	React.useEffect(() => {
		if (state.docSubmit.isSubmitted || state.docApprove.isApproved) 
		{
			fetchData({
				id: DocId.DocId,
				companyId: state.companyData.selectedCompanyId,
				office_id: state.auth.user.office
					? state.auth.user.office[0].office_id
					: "",
				actingOffices: actingOffices,
				assistant_offices:assistant_offices,

				page: pageNumber,
				limit: numberRowPerPage,
			});
			if(state.docSubmit.isSubmitted)
		       {
        socket.emit("newDocSubmitted",{DocId:DocId.DocId,companyId:state.companyData.selectedCompanyId});
			
		       }
		if(state.docApprove.isApproved)
		{
			socket.emit("newDocApproved",{DocId:DocId.DocId,companyId:state.companyData.selectedCompanyId});

		}
		}
	}, [state.docSubmit.isSubmitted, state.docApprove.isApproved]);

	React.useEffect(() => {
		if (docBody) {
			console.log("mounting  DocDetails  with docBody=", docBody);
			console.log("mounting  DocDetails  with data.data[0]=", data.data[0]);
			dispatch(
				saveDocBody({
					docId: DocId,
					docTypeId: data.data[0].DocType,
					docBody: docBody,
					docTitle: data.data[0].DocName,
				})
			);
		}
	}, [docBody, setDocBody]);

	React.useEffect(() => {
		if (state.docComment.isCommented) {
			setButtonClassname(
				clsx({
					[classes.buttonSuccess]: state.docComment.isCommented,
				})
			);

			setCommentBody();
			socket.emit("newDocCommented",{DocId:DocId.DocId,companyId:state.companyData.selectedCompanyId});
		}
	}, [state.docComment.isCommented]);
	React.useEffect(() => {
		setButtonClassname(
			clsx({
				[classes.buttonSuccess]: false,
			})
		);
		if (!commentBody) {
			fetchData({
				id: DocId.DocId,
				companyId: state.companyData.selectedCompanyId,
				office_id: state.auth.user.office
					? state.auth.user.office[0].office_id
					: "",
				actingOffices: actingOffices,
				assistant_offices:assistant_offices,

				page: pageNumber,
				limit: numberRowPerPage,
			});
		}
	}, [commentBody, setCommentBody]);
	React.useEffect(() => {
		dispatch(DocSubmitApproveCommentInitial());
	}, []);

	var pathname = window.location.pathname;
	console.log("pathname=", pathname);
	console.log("DocDetails real actingOffices=", actingOffices);
	
	try {
		console.log(
			"data.data.map(x=>x.x.comment)=",
			data.data.map((x) => x.comments)
		);
	} catch (e) {}

	console.log("DocDetails real assistant_offices=",assistant_offices);

	if (loading) {
		return <div>Loading</div>;
	}

	if (!loading && !data) {
		return <div>no Data found</div>;
	}
	if (data.data.length === 0) {
		return <div>no Data found</div>;
	}

	return (
		<div className={classes.root}>
			<div>
				Access Code
				<QRCode
					value={IP.reactServer + "DocDetail/" + DocId.DocId}
					logoImage="data:image/png;base64,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"
				/>
			</div>
			<Grid container spacing={3}>
				<>
					<Grid item xs={9}>
						<ExpansionPanel>
							<ExpansionPanelSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography className={classes.heading}>
									Document Info
								</Typography>
							</ExpansionPanelSummary>
							<ExpansionPanelDetails>
								<Box component="span" overflow="hidden" width={1}>
									<Table
										showSearch={false}
										Inputs={data}
										issuer="DocDetails"
										showActions={false}
										handleChangeTablePage={handleChangeTablePage}
										onChangeTableRowsPerPage={onChangeTableRowsPerPage}
										pageNumber={pageNumber}
										firstLoad={firstLoad}
										numberRowPerPage={numberRowPerPage}
										totalRow={totalRow}
										showCustomizedToolbar={false}
									/>
								</Box>
							</ExpansionPanelDetails>
						</ExpansionPanel>
						<ExpansionPanel>
							<ExpansionPanelSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel2a-content"
								id="panel2a-header"
							>
								<Typography className={classes.heading}>
									Attached Files
								</Typography>
							</ExpansionPanelSummary>
							<ExpansionPanelDetails>
								<InteractiveList
									input={files}
									handleFileClick={(x) => handleFileClick(x)}
									showDelete={showDelete}
								/>
							</ExpansionPanelDetails>
						</ExpansionPanel>
						<ExpansionPanel>
							<ExpansionPanelSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel3a-content"
								id="panel3a-header"
							>
								<Typography className={classes.heading}>Routes</Typography>
							</ExpansionPanelSummary>
							<ExpansionPanelDetails>
								<Steplist
									userdata={data.data[0].StepProgress}
									currentSteps={data.data[0].currentOfficeLocation}
								/>
							</ExpansionPanelDetails>
						</ExpansionPanel>
						<ExpansionPanel>
							<ExpansionPanelSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel4a-content"
								id="panel4a-header"
							>
								<Typography className={classes.heading}>History</Typography>
							</ExpansionPanelSummary>
							<ExpansionPanelDetails>
								<Box component="span" overflow="hidden" width={1}>
									<Table
										showSearch={true}
										Inputs={docsHistoryIn}
										issuer="DocDetails"
										showActions={false}
										handleChangeTablePage={handleChangeTablePage}
										onChangeTableRowsPerPage={onChangeTableRowsPerPage}
										pageNumber={pageNumber}
										firstLoad={firstLoad}
										numberRowPerPage={numberRowPerPage}
										totalRow={totalRow}
										showCustomizedToolbar={false}
									/>
								</Box>
							</ExpansionPanelDetails>
						</ExpansionPanel>
						<ExpansionPanel disabled>
							<ExpansionPanelSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel3a-content"
								id="panel3a-header"
							>
								<Typography className={classes.heading}></Typography>
							</ExpansionPanelSummary>
						</ExpansionPanel>
						{!state.docSubmit.isSubmitting &&
							!state.docSubmit.isSubmitted &&
							data.data[0].status === 3 &&
							data.data[0].action !== "Deleted" && (
								<Button
									variant="contained"
									color="primary"
									className={classes.button}
									endIcon={<Icon>send</Icon>}
									//onClick={handleDocSubmit}
									onClick={(e) => handleDocSubmitButton(e)}
								>
									Send
								</Button>
							)}

						<>
							{(data.data[0].OwnerOffice ===
								state.auth.user.office[0].office_id ||
								actingOffices.includes(data.data[0].OwnerOffice)||
								data.data[0].currentOfficeLocation ===
								state.auth.user.office[0].office_id||
								actingOffices.includes(data.data[0].currentOfficeLocation)

								) &&
								data.data[0].action !== "Deleted" && (
									<Button
										variant="contained"
										color="secondary"
										className={classes.button}
										endIcon={<ShareIcon />}
										onClick={(e) => handleDocShare()}
									>
										Share
									</Button>
								)}
						</>

						{(((data.data[0].status === 4 || data.data[0].status === 5) &&
							state.docApprove.isApproved === false &&
							(data.data[0].currentOfficeLocation ===
								state.auth.user.office[0].office_id ||
								actingOffices.includes(data.data[0].currentOfficeLocation)) &&
							data.data[0].action !== "Deleted") ||
							(false && // assign to true for admin to approve reject the doc
								state.userStatus.status.roles.filter((x) => x.role === "ADMIN")
									.length > 0 &&
								(data.data[0].status === 4 || data.data[0].status === 5))) && (
							<>
								<Button
									variant="contained"
									color="primary"
									className={classes.button}
									endIcon={<ThumbUpAltIcon />}
									onClick={(e) => handleDocApproval(e, ApproveStatus)}
								>
									Approve
								</Button>
								<Button
									variant="contained"
									color="secondary"
									className={classes.button}
									endIcon={<ThumbDownAltIcon />}
									onClick={(e) => handleDocApproval(e, 6)}
								>
									Reject
								</Button>
							</>
						)}
					</Grid>
					<Grid item xs={3}>
						Signatures
						<Signatures
							steps={data.data[0].StepProgress.map((x) => ({
								key: x.id,
								title: x.name,
								content: x.note,
								status: x.status,
							}))}
							signatureImage={signature}
							currentSteps={
								data.data[0].StepProgress.find(
									(x) => x.id === data.data[0].currentOfficeLocation
								).step
							}
						/>
					</Grid>
				</>
			</Grid>
			{FullScreenDialogInfo}

			<Divider />

			<Paper className={classes.paper}>
				Comment
				<TextEditor
					onHandleDocBodyChange={onHandleCommentBodyChange}
					docBody={commentBody}
					docTitle="Comment"
					showInputText={false}
					divErrorMessageId="commentError"
				/>
				<div className={classes.buttonRoot}>
					<div className={classes.wrapper}>
						<Fab
							aria-label="save"
							color="primary"
							className={buttonClassname}
							onClick={() => saveComment()}
						>
							{commentBody && state.docComment.isCommented ? (
								<CheckIcon />
							) : (
								<SaveIcon />
							)}
						</Fab>
						{state.docComment.isCommenting && (
							<CircularProgress size={68} className={classes.fabProgress} />
						)}
					</div>
				</div>
			</Paper>
			<Divider />
			{data.data[0].comments.map((x) => {
				return (
					<React.Fragment>
						<Card className={classes.root}>
							<CardHeader
								avatar={
									<UserImage
										username={
											state.auth.user.allUser.find(
												(y) => y._id === x.usernameId
											).username
										}
										name={
											state.auth.user.allUser.find(
												(y) => y._id === x.usernameId
											).name
										}
									/>
								}
								action={
									<IconButton aria-label="settings">
										<MoreVertIcon />
									</IconButton>
								}
								title={
									state.auth.user.allUser.find((y) => y._id === x.usernameId)
										.name
								}
								subheader={x.date}
							/>

							<CardContent>
								<div
									dangerouslySetInnerHTML={{
										__html: `${x.comment} `,
									}}
								></div>
							</CardContent>
							<CardActions disableSpacing>
								<IconButton
									className={clsx(classes.expand, {
										[classes.expandOpen]: expanded,
									})}
									onClick={handleExpandClick}
									aria-expanded={expanded}
									aria-label="show more"
								>
									<ExpandMoreIcon />
								</IconButton>
							</CardActions>
							<Collapse in={expanded} timeout="auto" unmountOnExit>
								<CardContent></CardContent>
							</Collapse>
						</Card>
					</React.Fragment>
				);
			})}
			<FullSavePDFFile
				open={openSavePDFFile}
				handleClose={handleCloseSavePDFFile}
				html={pdfHTML}
				name={pdfName}
			/>
		</div>
	);
};

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
function FullSavePDFFile(props) {
	const classes = useStyles();

	const savePDFFile = () => {
		const input = document.getElementById("pdfdiv");
		storeNotification.addNotification({
			title: "Downloading!",
			message: (
				<>
					in few second <ArrowDown />
				</>
			),
			type: "warning",
			insert: "bottom",
			container: "bottom-left",
			animationIn: ["animated", "fadeIn"],
			animationOut: ["animated", "fadeOut"],
			dismiss: {
				duration: 5000,
				onScreen: true,
				showIcon: true,
				click: true,
			},
		});

		html2canvas(input, { allowTaint: true }).then((canvas) => {
			var imgData = canvas.toDataURL("image/png");
			var imgWidth = 310;
			var pageHeight = 295;
			var imgHeight = (canvas.height * imgWidth) / canvas.width;
			var heightLeft = imgHeight;
			var doc = new jsPDF("p", "mm");
			var position = 0;

			doc.addImage(imgData, "PNG", 15, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;

			while (heightLeft >= 0) {
				position = heightLeft - imgHeight;
				doc.addPage();
				doc.addImage(imgData, "PNG", 15, position, imgWidth, imgHeight);
				heightLeft -= pageHeight;
			}

			doc.save(props.name.replace(/.docs/, "") + ".pdf");
		});
		props.handleClose();
	};
	return (
		<div>
			<Dialog
				fullScreen
				open={props.open}
				onClose={props.handleClose}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							onClick={props.handleClose}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							Document File
						</Typography>
						<Button autoFocus color="inherit" onClick={savePDFFile}>
							save
						</Button>
					</Toolbar>
				</AppBar>
				<div
					id="pdfdiv"
					dangerouslySetInnerHTML={{
						__html: `${props.html} `,
					}}
				/>
			</Dialog>
		</div>
	);
}

const UserImage = (props) => {
	const [image, setImage] = React.useState();
	const token = localStorage.getItem("token");
	const classes = useStyles();
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	React.useEffect(() => {
		new Promise(async (resolve, reject) => {
			let output = await axios.get(
				IP.nodeServer + "api/profileimage/" + props.username,
				config
			);
			//.get(IP.nodeServer + "api/profileimage/olivier.komeza", config);
			console.log("return output=", output);
			if (output) {
				try {
					var buffer = Buffer.from(output.data.image.picture.data).toString(
						"base64"
					);
					console.log(
						"comment images=",
						"data:image/png;base64," + buffer.toString(buffer)
					);
					setImage("data:image/png;base64," + buffer.toString(buffer));

					return resolve();
				} catch (e) {
					console.log("comment images error=", e);
					return reject();
				}
			}
		});
	}, []);

	return <Avatar alt={props.name} src={image} className={classes.avatar} />;
};

export default DocDetails;
